import { Box, Stack, Typography } from '@mui/material';
import { Paths } from '@shared/AppRoutes';
import { useAppNavigate } from '@shared/store';
import { useIntl } from 'react-intl';
import AppTheme from '@libs/mui/AppTheme';
import EmojiPeopleIcon from '@mui/icons-material/EmojiPeople';
import VisitDetailPriceColumn from './visit-detail-price-column';
import { ClickableCard } from '@shared/components/ClickableCard';
import { Autor } from '@features/visits/entity';

type VisitDetailCardProps = {
  date: string;
  paidPriceService: string;
  paidPriceGoods: string;
  index: number;
  visitId: string;
  clientId: string;
  serviceName: string;
  autor: Autor;
};

const VisitDetailCard = (props: VisitDetailCardProps) => {
  const { date, index, paidPriceService, paidPriceGoods, visitId, clientId, serviceName, autor } =
    props;
  const navigate = useAppNavigate();
  const intl = useIntl();

  return (
    <ClickableCard onClick={() => navigate(Paths.visitDetail(clientId, visitId))}>
      <Box
        sx={{
          position: 'absolute',
          borderRadius: '0% 0% 10px 0% ',
          textAlign: 'center',
          width: '20px',
          height: '20px',
          left: -2,
          top: -2,
          backgroundColor: AppTheme.palette.primary.light,
          display: 'flex',
          alignItems: 'center',
          lineHeight: 0,
          justifyContent: 'center',
        }}
      >
        <Typography variant="body1" color={AppTheme.palette.primary.main} fontSize="10px">
          {`${index}.`}
        </Typography>
      </Box>
      <Stack
        direction="row"
        marginTop={1}
        sx={{ padding: 1 }}
        justifyContent="space-between"
        alignItems="center"
      >
        <Stack direction="column">
          <Stack direction="row" spacing={1} alignItems="center">
            <Typography variant="body2" color="text.primary">
              {date}
            </Typography>
            {autor === Autor.CUSTOMER && <EmojiPeopleIcon sx={{ fontSize: '15px' }} color="info" />}
          </Stack>
          <Typography variant="body2" color="text.secondary" fontSize="12px">
            {serviceName}
          </Typography>
        </Stack>
        <VisitDetailPriceColumn
          color="warning"
          paidPrice={paidPriceGoods}
          label={intl.formatMessage({ id: 'visitDetailCard.goods', defaultMessage: 'Produkty' })}
        />
        <VisitDetailPriceColumn
          color="success"
          paidPrice={paidPriceService}
          label={intl.formatMessage({ id: 'visitDetailCard.service', defaultMessage: 'Služba' })}
        />
      </Stack>
    </ClickableCard>
  );
};

export default VisitDetailCard;
